"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserData = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const Hooks_1 = require("@/Hooks");
const user_1 = require("@/Redux/Actions/user");
const useUserData = () => {
    const page = (0, Hooks_1.useCurrentPage)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const userData = (0, react_redux_1.useSelector)((state) => state.user);
    (0, react_1.useEffect)(() => {
        if (userData) {
            return;
        }
        if (page) {
            dispatch((0, user_1.fetchUserData)());
        }
    }, [page, userData]);
    return userData;
};
exports.useUserData = useUserData;
exports.default = exports.useUserData;
